import PropTypes from "prop-types"
import React, { useContext, useEffect } from "react"
import { useTranslation } from "react-i18next"
import { NavLink, useLocation } from "react-router-dom"

import arrowLeftIcon from "../../assets/common/arrow-left-nav 2.svg"
import arrowLeftIconDark from "../../assets/common/arrow-line_dark.svg"
import InputField from "../../components/Common/Form/InputField"
import { useDarkMode } from "../../context/DarkModeContext"
import { GlobalContext } from "../../context/GlobalContext"
import { accordionType } from "../../utils/Constant"
import IrisCodeTroubleshootPanel from "../IrisCodeTroubleshootPanel"
import { userRoles } from "../Utility/userRoles"

const permissionDetails = userRoles().findUserRoles
let updateSubMenuItems

const AccordionPanel = ({
    title,
    subMenuItems,
    id,
    type,
    activeId,
    setActiveId,
    data,
    callbackData,
    displayComponent,
    roleAndPermissionPage,
    ...props
}) => {
    const { isDarkMode } = useDarkMode()
    
    // Choose arrow icon based on dark mode
    const arrowImage = isDarkMode ? arrowLeftIconDark : arrowLeftIcon
    const sortedSideNav = [...(subMenuItems || [])].sort((a, b) => 
        (a.title||a.sub_module_name).localeCompare((b.title||b.sub_module_name)))
    updateSubMenuItems = permissionDetails(sortedSideNav)
    
    const isOpen = (id === activeId)
    const location = useLocation()
    const { hamburger } = useContext(GlobalContext)

    useEffect(()=>{
        sessionStorage.setItem("currentActiveMenuId", activeId)     
    }, [activeId])
   
    useEffect(()=>{        
        sessionStorage.getItem("currentPath")
        if(location?.pathname === "/actionCode"){ 
            setActiveId(1)
        }
    }, [location?.pathname === "/actionCode"])
   
    const handleToggle = () => {
        isOpen ? setActiveId(null) : setActiveId(id)
    }
    const { t } = useTranslation()
    const isActiveMenu = (permissionId) => {
        const permission = userRoles().findUserRolesForPage(permissionId)
        return (permission?._read || permission?._update || permission?._write || permission?._delete) || false
    }

    // HIDE LEFT SIDE LABEL IF DOES'T HAVE READ PERMISSION OF ANY CHILD SUB MENU
    const isReadPermisson = (subMenu) => {
        const hasRead = subMenu?.map((x)=>{
            return x._read
        })
        return hasRead?.some((x)=> x ===true)
    }

    return subMenuItems !== undefined ? (
       
        <div
            className={ classSelector(type, accordionType, roleAndPermissionPage, displayComponent, isReadPermisson, updateSubMenuItems, hamburger) }
        >
            <button
                data-testid="accordian-title"
                onClick={ handleToggle }
                type="button"
                className={ buttonCLass(isOpen, type, accordionType) }
            >
                <span className={ `flex ${type === accordionType && "mx-3"}` }>
                    <NavLink
                        to={ props.path }
                        className="nav-link text-sm text-primary-50 dark:text-darkText "
                    >
                        { type === accordionType ? title : t(`sideBar.${title}`) }
                    </NavLink>
                </span>
                { accordianUPandDownImage(updateSubMenuItems, type, accordionType, roleAndPermissionPage, isOpen, isDarkMode) }
            </button>
            { subItemsMenu(updateSubMenuItems, type, accordionType, isOpen, isActiveMenu, t, arrowImage) }
            { subMenuItems && type === accordionType ? (
                <ul
                    className={ ulClassName(isOpen) }
                >
                    { !displayComponent ? 
                        <div className="flex flex-col gap-4">
                            <table className="table-auto">
                                { contentMarkupTHead(t) }
                                <tbody>
                                    { !!subMenuItems?.length &&
                  subMenuItems?.map((item, i) => (
                      <tr
                          key={ item.id }
                          className={ trClassName(subMenuItems, i) }
                      >
                          <td className="text-[13px] dark:text-white hover:text-primary-100 dark:hover:text-darkModeBlue h-7 px-3">
                              { item?.sub_module_name }
                          </td>
                          <td className="translate-x-9 py-2.5 align-middle">
                              <InputField
                                  id={ `fullaccess-${i}` }
                                  type="checkbox"
                                  name={ "fullaccess" }
                                  value={ item?.permission?.fullaccess }
                                  onChange={ (e) => callbackData(e, id, item, data) }
                              />
                          </td>

                          <td className="translate-x-10 py-2.5 align-middle">
                              <InputField
                                  id={ `write-${i}` }
                                  type="checkbox"
                                  name="write"
                                  value={
                                      item?.permission?._write || item?.permission?.write
                                  }
                                  onChange={ (e) => callbackData(e, id, item, data) }
                                  disabled={ title === "Work List Approval" || false }
                              />
                          </td>
                          <td className="translate-x-9 py-2.5 align-middle">
                              <InputField
                                  id={ `read-${i}` }
                                  type="checkbox"
                                  name="read"
                                  value={
                                      item?.permission?._read || item?.permission?.read
                                  }
                                  onChange={ (e) => callbackData(e, id, item, data) }
                                  disabled={ title === "Work List Approval" || false }
                              />
                          </td>

                          <td className="translate-x-9 py-2.5 align-middle">
                              <InputField
                                  id={ `update-${i}` }
                                  type="checkbox"
                                  name="update"
                                  value={
                                      item?.permission?._update ||
                            item?.permission?.update
                                  }
                                  onChange={ (e) => callbackData(e, id, item, data) }
                                  disabled={ title === "Work List Approval" || false }
                              />
                          </td>
                          <td className="translate-x-0 py-2.5 align-middle text-center">
                              <InputField
                                  id={ `delete-${i}` }
                                  type="checkbox"
                                  name="delete"
                                  value={
                                      item?.permission?._delete ||
                            item?.permission?.delete
                                  }
                                  onChange={ (e) => callbackData(e, id, item, data) }
                                  disabled={ title === "Work List Approval" || false }
                              />
                          </td>
                      </tr>
                  )) }
                                </tbody>
                            </table>
                        </div>
                        :
                        <div className="flex flex-col gap-4">
                            <IrisCodeTroubleshootPanel data={ props?.irisModule } contents={ subMenuItems }/>
                            { props?.irisModule?.data?.extraField ? 
                                <IrisCodeTroubleshootPanel data={ props?.irisModule?.data?.extraField?.[0] } 
                                    contents={ [props?.irisModule?.data.extraField?.[0]?.description] }/> : null }
                        </div> 
                    }
                </ul>
            ) : (
                []
            ) }
        </div>
    ) : (
        <div className="flex flex-col">
            <button
                data-testid="accordian-title"
                type="button"
                className={ "flex gap-4 text-left justify-between text-sm text-primary-50 dark:text-darkText font-bold py-2 " }
            >
                <span className="flex">
                    <NavLink to={ props.path } className="nav-link text-sm text-primary-50 dark:text-darkText">
                        { t(`sideBar.${title}`) }
                    </NavLink>
                </span>
            </button>
        </div>
    )
}

const classSelector =(type, accordionType, roleAndPermissionPage, displayComponent, isReadPermisson, updateSubMenuItems, hamburger)=>{
    return `flex flex-col ${type === accordionType && "rounded-lg mb-3"} 
            ${!roleAndPermissionPage && (displayComponent || (isReadPermisson(updateSubMenuItems)) ? "": "hidden")} ${hamburger && "hidden"}`
}

const buttonCLass =(isOpen, type, accordionType)=>{
    return `${isOpen ? "" : "!rounded-s-lg troubleshootBorderBottom"} 
                rounded-t-lg flex gap-4 text-left justify-between text-sm text-primary-50 dark:text-white 
                font-bold py-2 ${type === accordionType && "gap-4 border border-secondary-300 items-center"}` 
}

const trClassName =(subMenuItems, i)=>{
    return `h-10 border-secondary-300 group permissions hover:bg-lighestgray ${
        subMenuItems?.length - 1 === i
            ? " border-none"
            : "border-b"
    }` 
}
const ulClassName =(isOpen)=>{
    return `transition-max-height ease-in-out overflow-hidden gap-2 flex flex-col  ${
        isOpen
            ? `max-h-[2200px] px-3 pt-3 pb-3 gap-4 border 
                            border-secondary-300 active rounded-b-lg border-t-0`
            : "max-h-0"
    }` 
}
const accordianUPandDownImage =(updateSubMenuItems, type, accordionType, roleAndPermissionPage, isOpen, isDarkMode)=>{
    return updateSubMenuItems?.length > 0 ? (
        <span className={ `flex ${type === accordionType && "my-1 mr-3"}` }>
            <svg
                className={ ` ${roleAndPermissionPage ? "w-5 h-5" : "w-3 h-3"} 
            ${isOpen && "rotate-[180deg]"}` }
                xmlns="http://www.w3.org/2000/svg"
                width="32"
                height="20"
                viewBox="0 0 32 20"
                fill="none"
            >
                <path
                // eslint-disable-next-line max-len
                    d="M0.63241 1.50497C1.05402 1.08336 1.5532 0.872559 2.12996 0.872559C2.7056 0.872559 3.20421 1.08336 3.62582 1.50497L15.9789 13.8581L28.3742 1.46281C28.7677 1.06931 29.2596 0.872559 29.8498 0.872559C30.4401 0.872559 30.946 1.08336 31.3676 1.50497C31.7892 1.92658 32 2.42576 32 3.00252C32 3.57815 31.7892 4.07677 31.3676 4.49838L17.1594 18.6644C16.9908 18.833 16.8081 18.9528 16.6113 19.0236C16.4146 19.0933 16.2038 19.1282 15.9789 19.1282C15.7541 19.1282 15.5433 19.0933 15.3465 19.0236C15.1498 18.9528 14.9671 18.833 14.7984 18.6644L0.59025 4.45622C0.196751 4.06272 0 3.57815 0 3.00252C0 2.42576 0.210804 1.92658 0.63241 1.50497Z"
                    fill={isDarkMode ? "#ffffff" : "#002466"}
                />
            </svg>
        </span>
    ) : (
        <></>
    ) 
}

const subItemsMenu =(updateSubMenuItems, type, accordionType, isOpen, isActiveMenu, t, arrowImage)=>{
    return updateSubMenuItems && type !== accordionType && (
        <ul
            className={ `transition-max-height duration-700 ease-in-out overflow-hidden gap-2 flex flex-col  ${
                isOpen ? "max-h-[1000px] pt-2" : "max-h-0"
            }` }
        >
            { updateSubMenuItems?.map((item) => (
                <>
                    { isActiveMenu(item?.activity_id) ? (
                        helperLinkMethod(item, t(`sideBar.${item.title}`), arrowImage)
                    ) : (
                        <></>
                    ) }
                </>
            )) }
        </ul>
    )
}
const helperLinkMethod = (item, title, arrowImage) => {
    // eslint-disable-next-line no-prototype-builtins
    if (item.hasOwnProperty("fullaccess") && item._read) {
        return (
            
            <li key={ item.id }>
                <div className="flex">
                    <img
                        alt="ArrowLeft"
                        src={ arrowImage }
                        className="pr-1 w-[20px] h-[20px]"
                        height={ "10px" }
                        width={ "20px" }
                    />
                    <NavLink
                        to={ item.path }
                        className="nav-link text-sm text-primary-100 dark:text-darkModeBlue nav-link-subnav hover:underline hover:underline-offset-4"
                    >
                        { title }
                    </NavLink>
                </div>
            </li>
        )
    // eslint-disable-next-line no-prototype-builtins
    } else if (!item.hasOwnProperty("fullaccess")) {
        return (
            <li key={ item.id }>
                <NavLink
                    to={ item.path }
                    className="nav-link text-sm text-primary-100 dark:text-darkModeBlue nav-link-subnav"
                >
                    { title }
                </NavLink>
            </li>
        )
    }
}

const contentMarkupTHead =(t)=>{
    return (
        <thead className="bg-lightSkyblue h-12 text-[14px] dark:bg-darkCard rounded-lg">
            <tr>
                <th className="w-56 mx-5 text-primary-50 dark:text-white">
                    { t("RolesAndPermission.modulesTableHeaderSubModules") }
                </th>
                <th className="w-20 mx-5 text-primary-50 dark:text-white">
                    { t("RolesAndPermission.modulesTableHeaderFullAccess") }
                </th>
                <th className="w-20 mx-5 text-primary-50 dark:text-white">
                    { t("RolesAndPermission.modulesTableHeaderCreate") }
                </th>
                <th className="w-20 mx-5 text-primary-50 dark:text-white">
                    { t("RolesAndPermission.modulesTableHeaderRead") }
                </th>
                <th className="w-20 mx-5 text-primary-50 dark:text-white">
                    { t("RolesAndPermission.modulesTableHeaderUpdate") }
                </th>                                        
                <th className="w-20 mx-5 text-primary-50 dark:text-white">
                    { t("RolesAndPermission.modulesTableHeaderDelete") }
                </th>
            </tr>
        </thead>
    )
}
AccordionPanel.propTypes = {
    title: PropTypes.string.isRequired,
    subMenuItems: PropTypes.array,
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    type: PropTypes.string,
    activeId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    setActiveId: PropTypes.func,
    data: PropTypes.object,
    callbackData: PropTypes.func,
    displayComponent: PropTypes.bool,
    roleAndPermissionPage: PropTypes.bool,
    path: PropTypes.string,
    irisModule: PropTypes.object
}

export default AccordionPanel
